
import Authenticator from '../../components/Authenticator/Authenticator';
import { Pages } from '../../components/Pages/Pages';
import useSettings from '../../hooks/useSettings';
import AccommodationPage from '../../pages/AccommodationPage/AccommodationPage';
import CheckOngoingApplicationPage from '../../pages/CheckOngoingApplicationPage/CheckOngoingApplicationPage';
import CoApplicantPage from '../../pages/CoApplicantPage/CoApplicantPage';
import ContactDetailsPage from '../../pages/ContactDetailsPage/ContactDetailsPage';
import EmploymentPage from '../../pages/EmploymentPage/EmploymentPageSE';
import IncomePage from '../../pages/IncomePage/IncomePageSE';
import LivingConditionPage from '../../pages/LivingConditionPage/LivingConditionPage';
import PepPage from '../../pages/PepPage/PepPage';
import PurposeOfLoanPage from '../../pages/PurposeOfLoanPage/PurposeOfLoanPageDK';
import StatusProcessingPage from '../../pages/StatusPage/ProcessingPage/StatusProcessingPage';
import SubmitPage from '../../pages/SubmitPage/SubmitPage';
import VerifyIncomePageNO from '../../pages/VerifyIncomePage/VerifyIncomePageNO';

const SubmitApplicationWizard = () => {
    const settings = useSettings();

    return (
        <Pages>
            <ContactDetailsPage />
            <LivingConditionPage />
            <AccommodationPage />
            <EmploymentPage />
            <IncomePage />
            <VerifyIncomePageNO />
            <Authenticator autoLogin={true}>
                <CheckOngoingApplicationPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <IncomePage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <PepPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <PurposeOfLoanPage />
            </Authenticator>
            {settings.withCoApplicant && (
                <Authenticator autoLogin={true}>
                    <CoApplicantPage />
                </Authenticator>
            )}
            <Authenticator autoLogin={true}>
                <SubmitPage />
            </Authenticator>
            <Authenticator autoLogin={true}>
                <StatusProcessingPage />
            </Authenticator>
        </Pages>
    );
};

export default SubmitApplicationWizard;
